<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout-vertical",
    {
      scopedSlots: _vm._u([
        {
          key: "navbar",
          fn: function (ref) {
            var toggleVerticalMenuActive = ref.toggleVerticalMenuActive
            return [
              _c("navbar", {
                attrs: {
                  "toggle-vertical-menu-active": toggleVerticalMenuActive,
                },
              }),
            ]
          },
        },
      ]),
    },
    [_c("router-view")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/vertical/LayoutVertical.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import core_layouts_layout_vertical_LayoutVertical_vue from '@core/layouts/layout-vertical/LayoutVertical.vue';
import components_Navbar_vue from '../components/Navbar.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import AppCustomizer from '@core/layouts/components/app-customizer/AppCustomizer.vue'
// import { $themeConfig } from '@themeConfig'

export default ({
  render,
  staticRenderFns,
  components: {
    // AppCustomizer,
    LayoutVertical: core_layouts_layout_vertical_LayoutVertical_vue,
    Navbar: components_Navbar_vue
  },
  data() {
    return {
      // showCustomizer: $themeConfig.layout.customizer,
    };
  }
});

//# sourceURL=webpack:///./src/layouts/vertical/LayoutVertical.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

